import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemText, Button, Box } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Link } from 'react-router-dom';

import EditNewProject from '../../../components/Projects/EditNewProject';
import DeleteProject from '../../../components/Projects/DeleteProject';
import TransferProjectTesting from '../../../components/Projects/TransferProjectTesting';
import ArchiveProjects from '../../../components/Projects/ArchiveProjects';
import DuplicateProject from '../../../components/Projects/DuplicateProject';
import EditBudgetModal from '../../../components/Projects/EditBudgetModal';







const ProjectMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const [openProject, setOpenProject] = useState(false);
    const [openDeleteProject, setOpenDeleteProject] = useState(false);
    const [openTransfer, setOpenTransfer] = useState(false);
    const [openArchiveProjects, setOpenArchiveProjects] = useState(false);
    const [openDuplicate, setOpenDuplicate] = useState(false);
    const [openEditBudget, setOpenEditBudget] = useState(false);

    return (
        <>
            <Box component={Link} onClick={handleOpen} >
                <MoreHorizIcon sx={{ color: '#595959', fontFamily:'Manrope' }} />
            </Box>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} PaperProps={{ elevation: 3, sx: { borderRadius: '12px', padding: '4px 0', mt: 1, minWidth: 180, }, }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
                transformOrigin={{ vertical: 'top', horizontal: 'right', }}
            >
                <MenuItem onClick={() => { handleClose(); setOpenProject(true); }}
                    sx={{ fontSize: '14px', fontFamily: 'Manrope', '& MuiTypography-root': { fontFamily: 'Manrope' }, padding: '8px 16px', color: '#101828', '&:hover': { backgroundColor: '#F5F8FF', color: '#0076FE', }, }}>
                    <ListItemText sx={{ fontFamily: 'Manrope', }}>
                        Edit project</ListItemText>
                </MenuItem>

                <MenuItem onClick={() => { handleClose(); setOpenProject(true); }}
                    sx={{ fontSize: '14px', fontFamily: 'Manrope', '& MuiTypography-root': { fontFamily: 'Manrope' }, padding: '8px 16px', color: '#101828', '&:hover': { backgroundColor: '#F5F8FF', color: '#0076FE', }, }}>
                    <ListItemText sx={{ fontFamily: 'Manrope', }}>Manage members</ListItemText>
                </MenuItem>

                <MenuItem onClick={() => { handleClose(); setOpenProject(true); }}
                    sx={{ fontSize: '14px', fontFamily: 'Manrope', '& MuiTypography-root': { fontFamily: 'Manrope' }, padding: '8px 16px', color: '#101828', '&:hover': { backgroundColor: '#F5F8FF', color: '#0076FE', }, }}>
                    <ListItemText sx={{ fontFamily: 'Manrope', }}>Edit budget</ListItemText>
                </MenuItem>

                <MenuItem onClick={() => { handleClose(); setOpenDuplicate(true); }}
                    sx={{ fontSize: '14px', fontFamily: 'Manrope', '& MuiTypography-root': { fontFamily: 'Manrope' }, padding: '8px 16px', color: '#101828', '&:hover': { backgroundColor: '#F5F8FF', color: '#0076FE', }, }}>
                    <ListItemText sx={{ fontFamily: 'Manrope', }}>Duplicate project</ListItemText>
                </MenuItem>

                <MenuItem onClick={() => { handleClose(); setOpenArchiveProjects(true); }}
                    sx={{ fontSize: '14px', fontFamily: 'Manrope', '& MuiTypography-root': { fontFamily: 'Manrope' }, padding: '8px 16px', color: '#101828', '&:hover': { backgroundColor: '#F5F8FF', color: '#0076FE', }, }}>
                    <ListItemText sx={{ fontFamily: 'Manrope', }}>Archive project</ListItemText>
                </MenuItem>

                <MenuItem onClick={() => { handleClose(); setOpenTransfer(true); }}
                    sx={{ fontSize: '14px', fontFamily: 'Manrope', '& MuiTypography-root': { fontFamily: 'Manrope' }, padding: '8px 16px', color: '#101828', '&:hover': { backgroundColor: '#F5F8FF', color: '#0076FE', }, }}>
                    <ListItemText sx={{ fontFamily: 'Manrope', }}>Transfer</ListItemText>
                </MenuItem>

                <MenuItem onClick={() => { handleClose(); setOpenDeleteProject(true); }}
                    sx={{ fontSize: '14px', fontFamily: 'Manrope', '& MuiTypography-root': { fontFamily: 'Manrope' }, padding: '8px 16px', color: '#101828', '&:hover': { backgroundColor: '#F5F8FF', color: '#0076FE', }, }}>
                    <ListItemText sx={{ fontFamily: 'Manrope', }}>Delete project</ListItemText>
                </MenuItem>
            </Menu>

            <EditNewProject open={openProject} onClose={() => setOpenProject(false)} />
            <EditBudgetModal open={openEditBudget} onClose={() => setOpenEditBudget(false)} />
            <ArchiveProjects open={openArchiveProjects} onClose={() => setOpenArchiveProjects(false)} />
            <TransferProjectTesting open={openTransfer} onClose={() => setOpenTransfer(false)} />
            <DeleteProject open={openDeleteProject} onClose={() => setOpenDeleteProject(false)} />
            <DuplicateProject open={openDuplicate} onClose={() => setOpenDuplicate(false)} />
        </>
    );
};

export default ProjectMenu;